/**
 * FE-C2g batch-1: Account panel — contract paths for account.route.js.
 */

import { buildContractPath } from "./api/contract-client.js";

export const ACCOUNT_CONSOLE_TIMEOUT_MS = 16000;
export const ACCOUNT_CONSOLE_WRITE_TIMEOUT_MS = 12000;
export const ACCOUNT_AVATAR_UPLOAD_TIMEOUT_MS = 90000;

export function buildAdminUserScopesMePath() {
  return buildContractPath("get__admin_user-scopes_me");
}

export function buildPostAuthMeAvatarUploadPath() {
  return buildContractPath("post__auth_me_avatar_upload");
}

export function buildPatchAuthMeProfilePath() {
  return buildContractPath("patch__auth_me_profile");
}

export function buildPatchAuthMePasswordPath() {
  return buildContractPath("patch__auth_me_password");
}

export function buildPostAuthMeDeletePath() {
  return buildContractPath("post__auth_me_delete");
}

export function buildAuthMeAlertRecipientsPath() {
  return buildContractPath("get__auth_me_alert-recipients");
}

export function buildPostAuthMeAlertRecipientsRequestVerifyPath() {
  return buildContractPath("post__auth_me_alert-recipients_request-verify");
}

export function buildPostAuthMeAlertRecipientsPath() {
  return buildContractPath("post__auth_me_alert-recipients");
}

/** @param {string} recipientId */
export function buildDeleteAuthMeAlertRecipientPath(recipientId) {
  return buildContractPath("delete__auth_me_alert-recipients_p", { pathParams: [recipientId] });
}

/** @param {string} recipientId */
export function buildPatchAuthMeAlertRecipientPath(recipientId) {
  return buildContractPath("patch__auth_me_alert-recipients_p", { pathParams: [recipientId] });
}
